import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import gr from "../locales/gr.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en,
      gr,
    },
    fallbackLng: "gr",
    lng: "gr",
    interpolation: { escapeValue: false },
  });

export default i18n;
